import { Tab } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
    SecondaryTabsWrapper,
    SecondaryStyledTabs
    // EditPlanButton,
    // EditPlanActions,
    // ExitEditButton
} from '../../../themes/styles/plan-overview';
import { SecondaryTabsProps } from '../../../common/types/plan-overview-entity';
// import CloseIcon from '@mui/icons-material/Close';

export const SecondaryTabs = ({
    value,
    onChange,
    showSecondTab = false
}: // onEditPlan,
// selectedGoalIndex,
// isEditing,
// onExit
SecondaryTabsProps) => {
    const { t } = useTranslation();
    // const rerunLabel = t('BUTTON_RERUN', { defaultValue: 'Re-run' });
    // const closeLabel = t('BUTTON_CLOSE', { defaultValue: 'Close' });

    return (
        <SecondaryTabsWrapper>
            <SecondaryStyledTabs value={value} onChange={onChange}>
                <Tab label={t('LABEL_GOAL_OVERVIEW')} />
                {showSecondTab && <Tab label={t('LABEL_PORTFOLIO_DETAIL_PROJECTIONS')} />}
            </SecondaryStyledTabs>
            {/* {value === TabType.GoalOverview && !isEditing && (
                <EditPlanButton variant="outlined" onClick={() => onEditPlan(selectedGoalIndex)}>
                    {t('BUTTON_EDIT_PLAN')}
                </EditPlanButton>
            )} */}
            {/* {value === TabType.GoalOverview && isEditing && (
                <EditPlanActions>
                    <Button
                        variant="outlined"
                        sx={{
                            textTransform: 'none',
                            borderRadius: '100px',
                            padding: '10px 24px',
                            fontFamily: '"TT Commons Pro"',
                            fontSize: '16px',
                            fontWeight: 600,
                            color: '#3769FF',
                            border: '1px solid #3769FF',
                            '&:hover': {
                                backgroundColor: 'rgba(55, 105, 255, 0.04)',
                                border: '1px solid #3769FF'
                            }
                        }}
                    >
                        {rerunLabel}
                    </Button>
                    <ExitEditButton onClick={onExit} aria-label={closeLabel}>
                        <CloseIcon fontSize="small" />
                    </ExitEditButton>
                </EditPlanActions>
            )} */}
        </SecondaryTabsWrapper>
    );
};
